var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
export function Typography(_a) {
    var { as, className } = _a, props = __rest(_a, ["as", "className"]);
    const Element = as !== null && as !== void 0 ? as : 'div';
    return _jsx(Element, Object.assign({ className: clsx([className, 'text-balance leading-5 text-zinc-700 dark:text-zinc-300']) }, props));
}
